(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/draw-selector-components/assets/javascripts/hooks/use-draw-item-positions.js') >= 0) return;  svs.modules.push('/components/tipsen/draw-selector-components/assets/javascripts/hooks/use-draw-item-positions.js');
"use strict";


const {
  useEffect,
  useState
} = React;
const {
  useContainerResize
} = svs.components.tipsen.drawSelectorComponents.hooks;
const {
  DRAW_PANEL_WIDE_WIDTH,
  MARGIN_BASE
} = svs.components.tipsen.drawSelectorComponents.constants.elementSizes;

const LARGE_MARGIN_BASE = MARGIN_BASE * 1.5;
function useDrawItemPositions(drawItemRefs, shouldExpandHorizontally, indexOfCentered, indexOfSelected, containerEl) {
  const [triggerContainerVisibility, setTriggerContainerVisibility] = useState(false);
  const {
    containerWidth
  } = useContainerResize(containerEl);
  useEffect(() => {
    const selectDrawPanelWidth = () => {
      let drawPanelWidth = DRAW_PANEL_WIDE_WIDTH;
      if (containerEl) {
        containerEl.style.setProperty('--DRAW-ITEM-SUMMARY-HEIGHT', 'auto');
        if (!shouldExpandHorizontally) {
          const drawItemWidth = containerWidth - LARGE_MARGIN_BASE * 2;
          containerEl.style.setProperty('--DRAW-ITEM-MOBILE-WIDTH', "".concat(drawItemWidth, "px"));
          drawPanelWidth = drawItemWidth;
        }
        const pixelValue = containerEl.style.getPropertyValue('--DRAW-ITEM-MOBILE-WIDTH');
        drawPanelWidth = Number(pixelValue.replace(/\D/g, ''));
      }
      return shouldExpandHorizontally ? DRAW_PANEL_WIDE_WIDTH : drawPanelWidth;
    };
    const MARGIN = shouldExpandHorizontally ? MARGIN_BASE * 2 : MARGIN_BASE;
    const drawPanelWidth = selectDrawPanelWidth();
    const drawItemCenter = shouldExpandHorizontally ? drawPanelWidth + LARGE_MARGIN_BASE : (drawPanelWidth + MARGIN) / 2;
    const centerPosition = containerWidth / 2 - drawItemCenter;
    const offsetPosition = indexOfCentered * (drawPanelWidth + MARGIN);
    let summaryElHighestHeight = 0;
    if (drawItemRefs) {
      let currentIndexPosition = centerPosition - offsetPosition;
      const isSelectedInCenter = indexOfCentered === indexOfSelected;
      if (shouldExpandHorizontally && !isSelectedInCenter) {
        const isSelectedBeforeCenter = indexOfSelected < indexOfCentered;
        if (isSelectedBeforeCenter) {
          currentIndexPosition -= (drawPanelWidth + MARGIN) / 2;
        } else if (!isSelectedBeforeCenter) {
          currentIndexPosition -= -Math.abs(drawPanelWidth + MARGIN) / 2;
        }
      }
      drawItemRefs.forEach((ref, index) => {
        if (ref) {
          var _ref$querySelector;
          if (index !== 0 && shouldExpandHorizontally) {
            const isNextAfterCentered = index - indexOfCentered === 1;
            const isNextAfterSelected = index - indexOfSelected === 1;
            if (isSelectedInCenter && !isNextAfterCentered || !isSelectedInCenter && !isNextAfterSelected) {
              currentIndexPosition -= drawPanelWidth + MARGIN;
            }
          }
          ref.style.transform = "translate3d(".concat(currentIndexPosition, "px, 0, 0)");
          const summaryElHeights = (_ref$querySelector = ref.querySelector('.summary')) === null || _ref$querySelector === void 0 ? void 0 : _ref$querySelector.getBoundingClientRect().height;
          summaryElHighestHeight = Math.max(summaryElHighestHeight, summaryElHeights);
        }
      });
    }
    if (containerEl) {
      containerEl.style.setProperty('--DRAW-ITEM-SUMMARY-HEIGHT', "".concat(summaryElHighestHeight, "px"));
    }
  }, [containerEl, containerWidth, drawItemRefs, indexOfCentered, indexOfSelected, shouldExpandHorizontally]);
  useEffect(() => {
    setTriggerContainerVisibility(true);
  }, []);
  return {
    triggerContainerVisibility
  };
}
setGlobal('svs.components.tipsen.drawSelectorComponents.hooks.useDrawItemPositions', useDrawItemPositions);

 })(window);